import { useDisclosure } from '@chakra-ui/react';
import { BillGroupDunningStatusEnum } from '@monetize/types/app';
import { useResumeBillGroupDunning } from '../../../../api/dunningService';
import DataTableActions, {
  ActionType,
} from '../../../../components/Monetize/DataTable/MDataTableActions';
import { useConfirmModal } from '../../../../services/confirmModal';
import { PauseDunningModal } from './PauseDunningModal';

interface DunningActionsProps {
  billGroupId: string;
  dunningStatus: BillGroupDunningStatusEnum;
}

export const DunningActions = ({
  billGroupId,
  dunningStatus,
}: DunningActionsProps) => {
  const { showConfirmModal, closeModal, setModalLoading } = useConfirmModal();
  const {
    open: isPauseModalOpen,
    onOpen: onPauseModalOpen,
    onClose: onPauseModalClose,
  } = useDisclosure();

  const resumeDunning = useResumeBillGroupDunning({
    meta: { showErrorToast: true },
  });

  const handleResumeDunning = async () => {
    setModalLoading(true);
    await resumeDunning.mutateAsync({ billGroupId });
    setModalLoading(false);
    closeModal();
  };

  const onResumeDunning = () => {
    showConfirmModal({
      title: 'Resume Dunning',
      description:
        'Resuming dunning will restart automated past-due actions for this bill group.',
      onYes: () => {
        handleResumeDunning();
      },
    });
  };

  const actions: ActionType[] = [
    {
      title: 'Pause Dunning',
      enabled: dunningStatus === BillGroupDunningStatusEnum.IN_DUNNING,
      action: onPauseModalOpen,
    },
    {
      title: 'Resume Dunning',
      enabled: dunningStatus === BillGroupDunningStatusEnum.PAUSED,
      action: onResumeDunning,
    },
  ];

  return (
    <>
      <DataTableActions actions={actions} />
      {isPauseModalOpen && (
        <PauseDunningModal
          isOpen
          onClose={onPauseModalClose}
          billGroupId={billGroupId}
        />
      )}
    </>
  );
};
